import { Component, inject, input, LOCALE_ID } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RequestDetailsVTO } from '../../../../services/pharmacy/request.model';
import { StatusBadge } from '../../../shared/status-badge/status-badge';

@Component({
  selector: 'app-view-request-details',
  imports: [CommonModule, DatePipe, StatusBadge],
  templateUrl: './view-request-details.html',
  styleUrl: './view-request-details.scss',
  standalone: true,
})
export class ViewRequestDetails {
  data = input.required<RequestDetailsVTO>();
  isAdmin = input<boolean>(false);
  private localeId = inject(LOCALE_ID);

  getStatusStyles(status: string) {
    const s = status?.toLowerCase();
    switch (s) {
      case 'in progress':
        return { bg: 'bg-[#EFF6FF]', text: 'text-[#1D4ED8]', border: 'border-[#DBEAFE]' };
      case 'pending':
        return { bg: 'bg-[#FEFCE8]', text: 'text-[#854D0E]', border: 'border-[#FEF08A]' };
      case 'accepted':
        return { bg: 'bg-[#F0FDF4]', text: 'text-[#15803D]', border: 'border-[#DCFCE7]' };
      case 'rejected':
        return { bg: 'bg-[#FEF2F2]', text: 'text-[#B91C1C]', border: 'border-[#FEE2E2]' };
      case 'expired':
        return { bg: 'bg-[#F9FAFB]', text: 'text-[#374151]', border: 'border-[#F3F4F6]' };
      case 'feedback needed':
        return { bg: 'bg-[#FFFBEB]', text: 'text-[#92400E]', border: 'border-[#FEF3C7]' };
      default:
        return { bg: 'bg-gray-50', text: 'text-gray-600', border: 'border-gray-200' };
    }
  }
  getTranslatedTitle(obj: any): string {
    if (!obj) return '';
    return this.localeId.startsWith('ar') ? obj.titleAr : obj.titleEn;
  }
}
